<template>
  <div class="mob-inject">
    <template v-if="showHome">
        <div class="add-box" v-if="cloneSandtable.scenes && Object.keys(cloneSandtable.scenes).length === 0">
        <div
          class="add-inject"
          @click="addPoint"
        >{{$t('edit.sandboxs.addMark')}}</div>
        </div>
        <div class="follow-old" v-else>
          <!-- <div class="options" v-if="currentPID">
            <div class="options-btn" @click="editItem">{{$t('actionTitles.edit')}}</div>
            <div class="options-btn" @click="deleteItem">{{$t('actionTitles.delete')}}</div>
          </div> -->
          <div class="base-container">
            <div class="list-container">
              <div class="oild-list">
                <TPItem
                  v-for="(value, k) in cloneSandtable.scenes"
                  :key="k"
                  :itemObj="value"
                  valueKey="scene_id"
                  titleKey="scene_title"
                  :selectedId="currentPID"
                  @click.native="onClickItem(value)"
                ></TPItem>
              </div>
            </div>
            <div class="adds" @click="addPoint" v-show="showAddBtn">
                <div>
                    <img src="../../assets/img/mob_add_scene.png"/>
                    <h5>{{$t('edit.sandboxs.addPoint')}}</h5>
                </div>
            </div>
            <!-- <div class="add-new" @click="addPoint">
              <div class="text">{{$t('edit.sandboxs.addMark').slice(0,2)}}</div>
              <div class="text">{{$t('edit.sandboxs.addMark').slice(-2)}}</div>
            </div> -->
            <!-- 編輯沙盤 -->
    <edit-options
            v-if="editSandTableVisible"
            :options="options"
            @returnBack="closeOptions"
            @onclick="editOptions"
    ></edit-options>
          </div>
        </div>
    </template>
    <template v-if="showAddPoint">
      <AddPoint
        @onClickBack="onClickBack"
      ></AddPoint>
    </template>
  </div>
</template>

<script>
import ImageItem from "../ImageItem.vue";
import TPItem from "../TPItem";
import AddPoint from "./component/AddPoint"
import { mapGetters } from "vuex";
import EditOptions from "../EditOptions";

export default {
  components: { TPItem, ImageItem, AddPoint ,EditOptions},
  data() {
    return {
      allScenes: {},
      newName: "",
      renameObj: {},
      renameVisible: false,
      currentImage: {},
      selectedScene: [],
      currpoints: [],
      cloneSandtable: {},
      canChooseScenes: {},

      currentPID: "",
      showAddPoint: false,
      showHome: true,
      editTarget: null,
      isAddNew: true,
      editSandTableVisible:false,
      options:[
          {title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit'},
          {title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete'},
        ],
        showAddBtn: true,
    };
  },
  computed: {
    ...mapGetters([
      "vrbase",
      "currentScenesId",
      "editSandtable",
    ]),
  },
  watch: {
    editSandtable() {
      this.cloneSandtable = this.$deepClone(this.editSandtable);
    },
    currentScenesId(newValue) {
      this.currentPID = newValue;
    }
    // allScenes(){
    //   // this.setCanChooseScenes();
    // },
  },
  created() {
    this.cloneSandtable = this.$deepClone(this.editSandtable);
    // this.allScenes = this.vrbase.scenes; // 全部場景數據
    // this.setCanChooseScenes();
  },
  methods: {
    onClickItem(value) {
      this.editSandTableVisible=true;
      this.currentPID = value.scene_id;
      // lookto(value.ath, value.atv);
      this.$store.dispatch("loadScene", value.scene_id);
      this.editTarget = value;
    },
    addPoint() {
      this.resetEditData();
      this.isAddNew = true;
      this.showAddPoint = true
      this.showHome  = false;
    },
    updateSandtable() {
      // 更新cloneSandtable到store
      this.$store.commit("SET_EDIT_SANDTABLE", this.cloneSandtable);
    },

    resetEditData() {
      this.currentPID = "";
      this.editTarget = null;
      this.editSandTableVisible=false;
    },
    showHomePage() {
      this.showAddPoint = false
      this.showHome = true;
    },
    onClickBack() {
      this.showHomePage("home");
    },
    
    deleteItem() {
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          _this.$delete(_this.cloneSandtable.scenes, _this.editTarget.scene_id);
          _this.updateSandtable();
          _this.resetEditData();
        },
        onCancel() {
          console.log("取消");
        },
      });
      // this.setCanChooseScenes();
    },
    editItem() {
      this.showAddPoint = true
      this.showHome  = false;
      this.$store.dispatch("loadScene", this.editTarget.scene_id); // 選中編輯的場景
    },
     loadScene(id){
      this.$store.dispatch("loadScene", id);
      this.closeOptions();
    },
    //關閉編輯
    closeOptions(){
      this.editWalkVisible = false
      this.currHotId = ''
      this.showAddBtn = true
      this.editSandTableVisible=false;
    },
    //option的功能
    editOptions(type){
      if(type == 'edit'){
        this.editItem()
      }
      if(type == 'delete'){
        this.deleteItem()
      }
      this.editSandTableVisible=false;
      this.showAddBtn = true
    },
  },
};
</script>

<style lang="less" scoped>
// .mob-inject {
//   padding: 10px 0;
//   font-size: 12px;
//   color: white;
//   .add-inject {
//     height: 33px;
//     width: 80%;
//     border-radius: 5px;
//     color: rgba(255, 255, 255, 1);
//     background-color: rgba(90, 90, 90, 1);
//     margin: auto;
//     line-height: 33px;
//     text-align: center;
//   }
//   .follow-old {
//     .options {
//       display: flex;
//       justify-content: space-evenly;
//       .options-btn {
//         color: rgba(255, 255, 255, 1);
//         background-color: rgba(90, 90, 90, 1);
//         box-shadow: rgba(100, 100, 100, 1) solid 1px;
//         border-radius: 4px;
//         font-size: 12px;
//         width: 30%;
//         text-align: center;
//         height: 32px;
//         line-height: 32px;
//       }
//     }
//     .base-container {
//       display: flex;
//       align-items: center;
//       padding: 0 10px;
//       .list-container {
//         background-color: rgba(51, 51, 51, 1);
//         overflow-x: scroll;
//         width: calc(100% - 50px);
//         .oild-list {
//           display: flex;
//           padding: 8px 0;
//         }
//       }
//       .list-container::-webkit-scrollbar {
//         display: none;
//       }
//       .add-new {
//         width: 47px;
//         height: 47px;
//         color: white;
//         color: rgba(255, 255, 255, 1);
//         background-color: rgba(90, 90, 90, 1);
//         text-align: center;
//         font-size: 12px;
//         border-radius: 4px;
//         display: flex;
//         flex-direction: column;
//         justify-content: center;
//       }
//     }
//   }
//   // .selection {
//   //   .selection-top {
//   //     display: flex;
//   //     justify-content: space-between;
//   //     .click-btn {
//   //       padding: 2px 10px;
//   //       border-radius: 4px;
//   //       color: rgba(48, 48, 48, 1);
//   //       background-color: rgba(255, 255, 255, 1);
//   //     }
//   //   }
//   //   .selection-bottom {
//   //     display: flex;
//   //   }
//   // }
// }
</style>